'use strict';

function createStoreMixin(...stores) {
  var StoreMixin = {
    getInitialState() {
      return this.getStateFromStores(this.props);
    },

    componentWillMount() {
      this.stores = stores;
    },

    componentDidMount() {
      this.stores.forEach(store => store.addChangeListener(this.handleStoresChanged));
      this.setState(this.getStateFromStores(this.props));
    },

    componentWillUnmount() {
      this.stores.forEach(store => store.removeChangeListener(this.handleStoresChanged));
      this.stores = [];
    },

    handleStoresChanged() {
      if (this.isMounted()) {
        this.setState(this.getStateFromStores(this.props));
      }
    }
  };

  if (module.hot) {
    StoreMixin.componentDidUpdate = function () {
      if (stores !== this.stores && this.isMounted()) {
        this.stores.forEach(store => store.removeChangeListener(this.handleStoresChanged));
        this.stores = stores;
        this.stores.forEach(store => store.addChangeListener(this.handleStoresChanged));

        this.setState(this.getStateFromStores(this.props));
      }
    };
  }

  return StoreMixin;
}

module.exports = createStoreMixin;



/** WEBPACK FOOTER **
 ** ./mixins/createStoreMixin.js
 **/